import { render, staticRenderFns } from "./ManualGathering.vue?vue&type=template&id=f8afe5f4&"
import script from "./ManualGathering.vue?vue&type=script&lang=js&"
export * from "./ManualGathering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports